// Single source for turning a dataset's aggregate `job_status` into the pill
// label. Both the Data Sources card and the dataset details modal import this so
// the two can never disagree (previously the card mapped `failed` -> "Published"
// while the modal mapped it -> "Failed"). PRD-1119.
//
// Returns null for a falsy/absent job_status (caller falls back to the
// draft/published dataset.status label).
export function jobStatusToLabel(jobStatus) {
  if (!jobStatus) return null;
  const status = String(jobStatus).toLowerCase();
  if (status === 'complete' || status === 'completed') return 'Published';
  if (status === 'processing' || status === 'queued') return 'Processing';
  if (status === 'awaiting_input') return 'Review required';
  if (status === 'failed' || status === 'error') return 'Failed';
  return jobStatus.charAt(0).toUpperCase() + jobStatus.slice(1);
}

export default jobStatusToLabel;
